import React from 'react';

import TRANSLATIONS from './translations@default.json';

const SidebarHeading = () => (
	<div className="text-title-sm pb-1" data-testid="heading">
		{TRANSLATIONS.heading}
	</div>
);

export default SidebarHeading;
